export const TERMS_OF_SERVICE_META = {
  title: "Terms of Service",
  eyebrow: "Legal desk",
  updatedAt: "September 1, 2026",
  readMinutes: 8,
  summary: "Rules for P2P offers, accounts, fees, conduct, session breaks, settlements, and platform use.",
  intro: "Rules for using BetBond’s peer-to-peer platform. By continuing, you agree to these Terms.",
  platformNote:
    "BetBond is peer-to-peer sports matching infrastructure—we facilitate P2P offers and escrow. We are not a bookmaker, do not take the other side of your agreements, and earn only from disclosed service fees.",
};

export const TERMS_PROMISES = [
  {
    id: "not-house",
    label: "Not the house",
    detail: "We provide P2P matching and escrow tech—we don't bet against you.",
  },
  {
    id: "fee",
    label: "7% service fee",
    detail: "Shown before you confirm each P2P settlement; we may update rates with notice.",
  },
  {
    id: "adults",
    label: "18+ eligibility",
    detail: "You must meet the age of majority where you live to use BetBond.",
  },
  {
    id: "breaks",
    label: "Session breaks",
    detail: "Mandatory pauses after long continuous use help keep P2P play balanced.",
  },
];

export const TERMS_SECTIONS = [
  {
    id: "acceptance",
    title: "Acceptance & eligibility",
    index: "01",
    blocks: [
      {
        prose:
          "By using BetBond you agree to these Terms and applicable law. You must be at least 18, or the age of majority where you live. You confirm your information is accurate, you may legally use the service where you are, and you will not use BetBond for unlawful purposes. If you disagree, stop using the app.",
      },
    ],
  },
  {
    id: "platform",
    title: "What BetBond is",
    index: "02",
    blocks: [
      {
        prose:
          "BetBond is peer-to-peer sports matching software. You create or join P2P offers on fixtures, invite or accept counterparties, lock stakes in escrow, and settle when the match resolves. We are infrastructure—not a bookmaker or house. We do not set odds for you, do not take the opposing side of your P2P agreements, and do not gain or lose based on event outcomes. We earn revenue only from the disclosed service fee on activity we facilitate. Community chat and the weekly P2P leaderboard are part of the same platform.",
      },
    ],
  },
  {
    id: "fee",
    title: "Service fee",
    index: "03",
    blocks: [
      {
        prose:
          "We charge a 7% service fee on eligible completed P2P settlements processed through BetBond (typically on the winning side’s profit, as shown in the app). The fee is shown before you confirm. Publishing a community tip costs 100 COIN, charged when you post. We may update the rate or fee rules with reasonable notice, for example in the app or by email.",
      },
    ],
  },
  {
    id: "account",
    title: "Your account",
    index: "04",
    bullets: [
      "Keep your login secure and your profile information accurate",
      "Tell us promptly if you suspect unauthorized access",
      "One account per person unless we allow otherwise. Do not create accounts to evade restrictions.",
      "You may delete your account anytime in the app under Profile → Settings → Delete account",
      "Before deletion completes, settle wallet balances and finish or cancel open P2P offers and invites that affect other users",
      "Deleting your account ends your access to BetBond. This is separate from BetBond suspending or closing an account for Terms violations",
    ],
  },
  {
    id: "conduct",
    title: "Conduct & misuse",
    index: "05",
    blocks: [
      { prose: "You may not:" },
      {
        bullets: [
          "Break the law, harass others, or post illegal or harmful content in chat or offers",
          "Attack, scrape, or overload the service; use bots or cheats we prohibit",
          "Launder money, commit fraud, collude on P2P outcomes, or manipulate the platform",
        ],
      },
      {
        prose:
          "We may suspend or close accounts that violate these Terms or put others at risk.",
      },
    ],
  },
  {
    id: "session-breaks",
    title: "Session breaks & balanced use",
    index: "06",
    blocks: [
      {
        prose:
          "BetBond may require mandatory breaks after extended continuous use. When you stay active for a long stretch without a meaningful pause, we may pause P2P staking and certain wallet transactions for a cooling period shown in the app (currently about three hours of continuous use, followed by about a ten-minute break). We aim to warn you when about ten minutes of session time remain. If you are inactive for a short period (currently about five minutes), your continuous session may reset. During a break you may browse; P2P and similar actions resume automatically when the timer ends.",
      },
      {
        prose:
          "Break limits may vary by account type, may not apply to certain staff or partner accounts, and may change with reasonable notice in the app or by email.",
      },
    ],
  },
  {
    id: "settlements",
    title: "Settlements & disputes",
    index: "07",
    blocks: [
      {
        prose:
          "P2P escrow and payouts follow the product rules shown in the app and the conditions users agree on each offer (including seats, stake, and market selection). Where fixture results matter, we may rely on independent sports data to apply those rules. Contact support promptly if something looks wrong; we aim to respond in line with our support practices. Voided or error cases may be refunded or corrected as described in the app.",
      },
    ],
  },
  {
    id: "ip",
    title: "Intellectual property",
    index: "08",
    blocks: [
      {
        prose:
          "BetBond-owned branding, software, and content stay ours. For content you post, you give BetBond a license to host and display it on the service. You must have the rights to anything you upload.",
      },
    ],
  },
  {
    id: "legal",
    title: "Disclaimers, liability & law",
    index: "09",
    blocks: [
      {
        prose:
          'The service is provided "as is" and "as available." To the fullest extent allowed by law, BetBond is not liable for indirect or consequential losses, or losses beyond amounts you paid us in fees in the six months before a claim. You use the platform at your own risk as to arrangements with other users and any financial exposure you accept.',
      },
      {
        prose: "These Terms are governed by the laws of Rwanda. Contact: betbondofficial@gmail.com",
        email: "betbondofficial@gmail.com",
      },
    ],
  },
];
